import { useRef, useState } from "react";
import ReactDatePicker from "react-datepicker";

import { WARRANTY_TIME_PERIODS, useGetTimePeriodOptions, useGetWarrantyDashboardFilters } from "modules/WarrantyDashboard/hooks";
import { getFormattedDateRange } from "utils/dateHelperFunctions";

type UsePinPeriodDropdownProps = {
  selectedWarrantyTimePeriod: WARRANTY_TIME_PERIODS;
  handleDateChange: (dates: [Date | null, Date | null]) => void;
};

export const usePinPeriodDropdown = ({ handleDateChange, selectedWarrantyTimePeriod }: UsePinPeriodDropdownProps) => {
  const [show, setShow] = useState(false);
  const datePickerRef = useRef<ReactDatePicker | null>(null);
  const timePeriodOptions = useGetTimePeriodOptions();
  const {
    filters: { pin_date_from, pin_date_to }
  } = useGetWarrantyDashboardFilters();

  const startDate = pin_date_from ? new Date(pin_date_from) : undefined;
  const endDate = pin_date_to ? new Date(pin_date_to) : undefined;

  const updatedTimePeriodOptions = timePeriodOptions.map(tPeriod => {
    if (tPeriod.value === WARRANTY_TIME_PERIODS.CustomTimePeriod && selectedWarrantyTimePeriod === WARRANTY_TIME_PERIODS.CustomTimePeriod) {
      return { ...tPeriod, text: `${tPeriod.text} ${getFormattedDateRange(startDate, endDate)}` };
    }
    return tPeriod;
  });
  const currentTimePeriodLabel = updatedTimePeriodOptions.find(element => element.value === selectedWarrantyTimePeriod)?.text;

  const handleOpenDatePicker = () => {
    if (datePickerRef.current instanceof ReactDatePicker) {
      datePickerRef.current.setOpen(true);
      setShow(true);
    }
  };

  const handleCloseDatePicker = () => {
    if (datePickerRef.current instanceof ReactDatePicker) {
      datePickerRef.current.setOpen(false);
      setShow(false);
    }
  };

  const handleResetDateRange = () => handleDateChange([null, null]);

  const onDateChange = ([start, end]: [Date | null, Date | null]) => {
    handleDateChange([start, end]);
    if (start && end) handleCloseDatePicker();
  };

  return {
    show,
    endDate,
    startDate,
    datePickerRef,
    currentTimePeriodLabel,
    updatedTimePeriodOptions,
    onDateChange,
    handleOpenDatePicker,
    handleResetDateRange,
    handleCloseDatePicker
  };
};
